import styled, { css } from 'styled-components';
import {
  SCHEDULER_TAB_ITEM_SPACING,
  SCHEDULER_TAB_ITEM_SPACING_LEGACY,
  SCHEDULER_TAB_ITEM_SPACING_MOBILE,
  SCHEDULER_TAB_PILL_PADDING,
  SCHEDULER_TAB_PILL_PADDING_MOBILE,
  schedulerTabBottomIndicatorStyles,
  SIDEBAR_SPACE_4,
  SIDEBAR_SPACE_8,
  SIDEBAR_SPACE_24,
} from 'styles/sidebarMenuListItemHighlight';
import { breakpoints } from 'theme';

export const DocIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const TabLabel = styled.span``;

export const CommentIconWrapper = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const IconBadge = styled.span`
  position: absolute;
  top: -4px;
  right: -6px;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.color.brightTurquoise};
  color: ${({ theme }) => theme.color.white};
  font-size: 9px;
  line-height: 1;
  font-weight: 600;
  pointer-events: none;
`;

const tabPillSurfaceStyles = css`
  border-radius: ${SIDEBAR_SPACE_24};
  border: none;
  transition: 0.25s;

  @media ${breakpoints.smPlus} {
    padding: ${SCHEDULER_TAB_PILL_PADDING};
  }

  @media ${breakpoints.downSmPlus} {
    padding: ${SCHEDULER_TAB_PILL_PADDING_MOBILE};
  }
`;

const tabPillActiveStyles = css`
  color: ${({ theme }) => theme.color.white};
  background-color: ${({ theme }) => theme.color.brightTurquoise};
  ${DocIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.white};
      }
    }
  }
  ${CommentIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.white};
      }
    }
  }
  ${IconBadge} {
    background-color: ${({ theme }) => theme.color.white};
    color: ${({ theme }) => theme.color.brightTurquoise};
  }
`;

export const TabPill = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  ${tabPillSurfaceStyles}

  ${({ isActive }) => isActive && tabPillActiveStyles}
`;

export const TabBottomIndicator = styled.span`
  ${schedulerTabBottomIndicatorStyles}

  @media ${breakpoints.downSmPlus} {
    width: calc(100% - ${SIDEBAR_SPACE_4} * 2);
  }
`;

export const StyledTab = styled.li`
  &:not(:last-child) {
    margin-right: ${({ isSidebar, withBottomIndicator, marginRight }) => {
      if (withBottomIndicator) {
        return SCHEDULER_TAB_ITEM_SPACING;
      }
      if (isSidebar) {
        return SIDEBAR_SPACE_4;
      }
      return marginRight || SCHEDULER_TAB_ITEM_SPACING_LEGACY;
    }};

    @media ${breakpoints.downSmPlus} {
      margin-right: ${({ isSidebar, withBottomIndicator, marginRight }) => {
        if (withBottomIndicator) {
          return SCHEDULER_TAB_ITEM_SPACING_MOBILE;
        }
        if (isSidebar) {
          return SIDEBAR_SPACE_4;
        }
        return marginRight || SCHEDULER_TAB_ITEM_SPACING_MOBILE;
      }};
    }
  }

  cursor: pointer;
  display: flex;
  flex-direction: ${({ withBottomIndicator }) =>
    withBottomIndicator ? 'column' : 'row'};
  align-items: center;
  flex-shrink: 0;
  scroll-snap-align: start;
  font-size: 14px;
  position: relative;
  color: ${({ theme }) => theme.color.baliHai};
  white-space: nowrap;

  @media ${breakpoints.downSmPlus} {
    font-size: 13px;
    line-height: 16px;
  }
  ${DocIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.baliHai};
      }
    }
  }
  ${CommentIconWrapper} {
    & > svg {
      path {
        fill: ${({ theme }) => theme.color.baliHai};
      }
    }
  }

  ${({ withBottomIndicator }) =>
    !withBottomIndicator &&
    css`
      &:hover {
        color: ${({ theme }) => theme.color.white};
        background-color: ${({ theme }) => theme.color.brightTurquoise};
        ${DocIconWrapper} {
          & > svg {
            path {
              fill: ${({ theme }) => theme.color.white};
            }
          }
        }
        ${CommentIconWrapper} {
          & > svg {
            path {
              fill: ${({ theme }) => theme.color.white};
            }
          }
        }
        ${IconBadge} {
          background-color: ${({ theme }) => theme.color.white};
          color: ${({ theme }) => theme.color.brightTurquoise};
        }
      }

      border-radius: ${SIDEBAR_SPACE_24};
      border: none;

      @media ${breakpoints.smPlus} {
        padding: ${({ isSidebar }) =>
          isSidebar ? SIDEBAR_SPACE_8 : SCHEDULER_TAB_PILL_PADDING};
        margin: ${({ isSidebar }) =>
          isSidebar ? `${SIDEBAR_SPACE_4} ${SIDEBAR_SPACE_8}` : 'auto 0'};
        transition: 0.25s;
      }

      @media ${breakpoints.downSmPlus} {
        padding: ${SCHEDULER_TAB_PILL_PADDING_MOBILE};
      }

      ${({ isActive }) => isActive && tabPillActiveStyles}
    `}

  ${({ withBottomIndicator }) =>
    withBottomIndicator &&
    css`
      padding: 0;
      margin: 0;
      background: none;
      border-radius: 0;

      &:hover ${TabPill}, &:focus-visible ${TabPill} {
        ${tabPillActiveStyles}
      }

      &:hover ${TabBottomIndicator}, &:focus-visible ${TabBottomIndicator} {
        transform: scaleX(1);
      }
    `}

  ${({ withBottomIndicator, isActive }) =>
    withBottomIndicator &&
    isActive &&
    css`
      ${TabPill} {
        ${tabPillActiveStyles}
      }

      ${TabBottomIndicator} {
        transform: scaleX(1);
      }
    `}
`;

export const StyledItemPlaceholder = styled.div`
  flex-grow: 1;
`;
